import {Component} from "preact";
import ConfigService from "../../../services/ConfigService";
import {translate, TranslateService} from "../../../services/TranslateService";

export default class Text extends Component {
    static defaultProps = {
        text: null,
        translatable: null
    };

    componentDidMount() {
        ConfigService.currentLanguage.subscribe(this.updateText);
    }

    componentWillUnmount() {
        ConfigService.currentLanguage.unsubscribe(this.updateText);
    }

    render(props, state, context) {
        return props.text ? translate(props.text) : (props.translatable ? TranslateService.translatable(props.translatable) : '');
    }

    updateText = () => {
        this.forceUpdate();
    }
}



// WEBPACK FOOTER //
// ./components/common/text/index.js